module.exports = __webpack_public_path__ + "img/low.2b9e52ba.svg";